import { configureStore } from "@reduxjs/toolkit";
import {
  msgReducer,
  groupsReducer,
  cardsReducer,
  userReducer,
  inspectionsReducer,
  errorReducer,
  loadingReducer,
  screenPermissionSliceReducer,
  reportReducer,
  reportTypeReducer,
  dataUsageReducer,
  groupDetailReducer,
} from "@app/store";
export const store = configureStore({
  reducer: {
    msg: msgReducer,
    groups: groupsReducer,
    cards: cardsReducer,
    user: userReducer,
    inspection: inspectionsReducer,
    error: errorReducer,
    loading: loadingReducer,
    screenPermission: screenPermissionSliceReducer,
    report: reportReducer,
    reportType: reportTypeReducer,
    dataUsage: dataUsageReducer,
    groupDetail: groupDetailReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
